import { useContext, useEffect, useState } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import { Button, Card, Col, Form, Image, Modal, Row } from "react-bootstrap";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { Link, useHistory } from "react-router-dom";
import { Field, FieldArray, Formik } from "formik";
import Select from "react-select";
import * as Yup from "yup";
import Post from "../../../api/Post";
import Get from "../../../api/Get";
import { ENCUESTA_ADD, ENCUESTA_GET } from "../../../api/Routes";
import { authContext } from "../../../context/AuthContext";
import LoadingList from "../../../loader/LoadingList";
import useQuery from "../../../hook/useQuery";
import { withTranslation } from "react-i18next";
import ComponentModalErrorSever from "../../../components/ComponentModalErrorSever";
import iconRecheck from "../../../img/icons/recheck.svg";
import { FaPlus, FaTrash } from "react-icons/fa";

const userTypeOpt = [
  { value: "Patient", label: "Paciente" },
  { value: "Doctor", label: "Doctor" },
];
const questionsOpt = [
  { value: 1, label: "Texto" },
  { value: 3, label: "Opción Múltiple" },
  { value: 4, label: "Lineal" },
  { value: 5, label: "Selección Individual" },
];

function AddEncuesta({ t }) {
  const history = useHistory();
  const { auth } = useContext(authContext);
  let accesToken = auth?.data?.access_token;
  const query = useQuery();
  const id = query.get("id");
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    id: null,
    title: "",
    activo: true,
    options: [],
    questionType: {
      id: "",
    },
    userType: "Patient",
    company: auth.data.company,
    sorder: 1,
  });

  Yup.addMethod(Yup.array, "unique", function (message, mapper = (a) => a) {
    return this.test("unique", message, function (list) {
      return list.length === new Set(list.map(mapper)).size;
    });
  });

  const shemaValidate = Yup.object().shape({
    title: Yup.string().required(t("Camporequerido")),
    sorder: Yup.number()
      .required(t("Camporequerido"))
      .min(1, "Campo debe ser mayor o igual a 1"),
    questionType: Yup.object().shape({
      id: Yup.string().required(t("Camporequerido")),
    }),
    // options: Yup.array().of(Yup.string().required(t('Camporequerido')))
    //         .unique('No se puede crear dos campos iguales', a => a),
    options: Yup.array().when("questionType", {
      is: (val) => val && parseInt(val.id) === 4,
      then: Yup.array()
        .of(
          Yup.number()
            .typeError("Campo numérico")
            .required(t("Camporequerido"))
            .min(1, "Campo debe ser mayor o igual a 1")
        )
        .unique("No se puede crear dos campos iguales", (a) => a),
      otherwise: Yup.array()
        .of(Yup.string().required(t("Camporequerido")))
        .unique("No se puede crear dos campos iguales", (a) => a),
    }),
  });

  const [errorServer, setErrorServer] = useState(null);
  const [showModalServer, setShowModalServer] = useState(false);
  const handleCloseModalServer = () => {
    setShowModalServer(false);
  };
  const [showSuccess, setShowSuccess] = useState(false);
  const handleCloseSuccess = () => setShowSuccess(false);

  useEffect(() => {
    if (id) {
      setLoading(true);
      Get({ url: `${ENCUESTA_GET}/${id}`, access_token: accesToken })
        .then((resp) => {
          console.log(resp);
          setInitialValues({
            id: resp.data.data.id,
            title: resp.data.data.title,
            activo: resp.data.data.activo,
            company: resp.data.data.company,
            options: resp.data.data.options,
            questionType: resp.data.data.questionType,
            userType: resp.data.data.userType,
            sorder: resp.data.data.sorder,
          });
          setLoading(false);
        })
        .catch((error) => {
          setShowModalServer(true);
          if (error.response) {
            setErrorServer(error.response);
          }
          setLoading(false);
        });
    }
  }, [id, accesToken]);

  return (
    <>
      {loading ? (
        <LoadingList texto="" />
      ) : (
        <>
          <div className="body">
            <Row className="align-items-center">
              <Col xs="12" md="8">
                <h2 className="mb-0 title-top">{`${
                  id ? "Editar " : "Agregar "
                }encuesta`}</h2>
              </Col>
              <Col xs="12" md="4" className="text-right">
                <IoIosCloseCircle
                  className="cancel-btn"
                  onClick={(e) => history.goBack()}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Formik
                  initialValues={initialValues}
                  validationSchema={shemaValidate}
                  onSubmit={(values, { setSubmitting, setFieldValue }) => {
                    console.log(values);
                    Post({
                      url: ENCUESTA_ADD,
                      data: values,
                      header: true,
                      access_token: accesToken,
                    })
                      .then((response) => {
                        console.log(response);
                        setSubmitting(false);
                        if (response.data.state) {
                          setShowSuccess(true);
                          setTimeout(() => {
                            setShowSuccess(false);
                            history.goBack();
                          }, 2000);
                        } else {
                          setShowModalServer(true);
                          setErrorServer(response);
                        }
                      })
                      .catch((error) => {
                        setSubmitting(false);
                        setShowModalServer(true);
                        if (error.response) {
                          setErrorServer(error.response);
                        }
                      });
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                  }) => (
                    <Form onSubmit={handleSubmit} className="mt-3">
                      {isSubmitting && (
                        <LoadingList texto="Procesando información" />
                      )}
                      <Card className="shadow-1 formSection">
                        <Card.Body>
                          <Row>
                            <Col xs="9" md="9">
                              <Form.Group>
                                <Form.Label className="font-weight-bold-600 text-secondary">
                                  Título <span className="text-danger">*</span>
                                </Form.Label>
                                <Field
                                  type="text"
                                  className={`form-control input-form ${
                                    errors.title && "error"
                                  }`}
                                  name="title"
                                />
                                {errors.title && (
                                  <div className="invalid-feedback d-block">
                                    {errors.title}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col xs="3" md="3">
                              <div className="switch-container">
                                <Form.Group>
                                  <Form.Label className="font-weight-bold-600 text-secondary">
                                    Activo
                                  </Form.Label>
                                  <br />
                                  <BootstrapSwitchButton
                                    checked={values.activo}
                                    onlabel="On"
                                    onstyle="success"
                                    offlabel="Off"
                                    offstyle="danger"
                                    width={69}
                                    size="md"
                                    onChange={(value) =>
                                      setFieldValue("activo", value)
                                    }
                                  />
                                </Form.Group>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="12" md="4">
                              <Form.Group>
                                <Form.Label className="font-weight-bold-600 text-secondary">
                                  Tipo Pregunta{" "}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Select
                                  name="partner"
                                  options={questionsOpt}
                                  value={
                                    values.questionType.id
                                      ? {
                                          id: values.questionType,
                                          label: questionsOpt.find(
                                            (it) =>
                                              it.value ===
                                              values.questionType.id
                                          ).label,
                                        }
                                      : null
                                  }
                                  onChange={(item) => {
                                    setFieldValue(
                                      "questionType.id",
                                      item?.value
                                    );
                                    if (item?.value === 1) {
                                      setFieldValue("options", []);
                                    }
                                  }}
                                />
                                {errors.questionType?.id && (
                                  <div className="invalid-feedback d-block">
                                    {errors.questionType.id}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col xs="12" md="4">
                              <Form.Group>
                                <Form.Label className="font-weight-bold-600 text-secondary">
                                  Tipo de usuario{" "}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Select
                                  name="userType"
                                  options={userTypeOpt}
                                  value={
                                    values.userType
                                      ? {
                                          id: values.userType,
                                          label: userTypeOpt.find(
                                            (it) => it.value === values.userType
                                          ).label,
                                        }
                                      : null
                                  }
                                  onChange={(item) => {
                                    setFieldValue("userType", item?.value);
                                  }}
                                />
                                {errors.questionType?.id && (
                                  <div className="invalid-feedback d-block">
                                    {errors.questionType.id}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                            <Col xs="12" md="2">
                              <Form.Group>
                                <Form.Label className="font-weight-bold-600 text-secondary">
                                  Orden <span className="text-danger">*</span>
                                </Form.Label>
                                <Field
                                  type="number"
                                  className={`form-control input-form ${
                                    errors.sorder && "error"
                                  }`}
                                  name="sorder"
                                />
                                {errors.sorder && (
                                  <div className="invalid-feedback d-block">
                                    {errors.sorder}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                          </Row>
                          {values.questionType?.id !== 1 && (
                            <Row>
                              <Col xs="12" md="12">
                                <Form.Group>
                                  <Form.Label className="font-weight-bold-600 text-secondary">
                                    Opciones{" "}
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <FieldArray
                                    name="options"
                                    render={(arrayHelper) => (
                                      <div>
                                        {values.options &&
                                          values.options.length > 0 &&
                                          values.options.map((item, index) => (
                                            <Row
                                              key={index}
                                              className="align-items-center mb-1"
                                            >
                                              <Col xs="2" md="2">
                                                <div className="form-check form-check-inline m-0">
                                                  <Field
                                                    className="form-control"
                                                    name={`options.${index}`}
                                                    type="text"
                                                  />
                                                </div>
                                              </Col>
                                              <Col xs="1" md="1">
                                                <Button
                                                  type="button"
                                                  variant="danger"
                                                  size="sm"
                                                  onClick={() =>
                                                    arrayHelper.remove(index)
                                                  }
                                                >
                                                  <FaTrash />
                                                </Button>
                                              </Col>
                                              <Col xs="12" md="12">
                                                {errors?.options?.length > 0 &&
                                                  Array.isArray(
                                                    errors?.options
                                                  ) &&
                                                  errors?.options[index] && (
                                                    <div className="invalid-feedback d-block">
                                                      {errors?.options[index]}
                                                    </div>
                                                  )}
                                              </Col>
                                            </Row>
                                          ))}
                                        {errors.options &&
                                          !Array.isArray(errors.options) && (
                                            <div className="invalid-feedback d-block">
                                              {errors.options}
                                            </div>
                                          )}
                                        <Button
                                          type="button"
                                          variant="outline-primary"
                                          className="mt-2"
                                          size="sm"
                                          onClick={() => arrayHelper.push("")}
                                        >
                                          <FaPlus className="mr-2" />
                                          Agregar nueva opción
                                        </Button>
                                      </div>
                                    )}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          )}
                        </Card.Body>
                      </Card>

                      <Row className="grupoBotones">
                        <Col className="text-right">
                          <Link
                            to="/admin/encuesta"
                            className="btn btn-danger cancelar-buttom"
                          >
                            Cancelar
                          </Link>{" "}
                          <Button
                            variant="outline-success"
                            className="ok-buttom"
                            type="submit"
                          >{`${id ? "Editar" : "Agregar"}`}</Button>{" "}
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </Col>
            </Row>
          </div>
        </>
      )}

      <ComponentModalErrorSever
        show={showModalServer}
        handleClose={handleCloseModalServer}
        error={errorServer}
      />

      <Modal
        show={showSuccess}
        onHide={handleCloseSuccess}
        centered
        className="border-0"
      >
        <Modal.Body className="p-0">
          <div className="text-center position-relative overflow-hidden h-100p">
            <Image src={iconRecheck} fluid className="img-recheck" />
            <h5 className="mb-0 text-app-success">
              {" "}
              {t("solicitud_exitosa")}{" "}
            </h5>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default withTranslation()(AddEncuesta);
